import type { ReactNode } from "react";
import { isValidElement } from "react";
import React from "react";
import IconEdit from "../../../icons/IconEdit";
import IconShare from "../../../icons/IconShare";
import IconTrash from "../../../icons/IconTrash";
import IconClose from "../../../icons/IconClose";
import IconDocument from "../../../icons/IconDocument";
import IconCamera from "../../../icons/IconCamera";
import IconImage from "../../../icons/IconImage";
import IconScan from "../../../icons/IconScan";
import IconEye from "../../../icons/IconEye";
import IconCheck from "../../../icons/IconCheck";
import IconDetails from "../../../icons/IconDetails";
import IconStatus from "../../../icons/IconStatus";
import type { ActionSheetIconId, InternalActionSheetOptions } from "./types";

export const AUTO_ICON_MAP: Record<string, ReactNode> = {
  details: <IconDetails />,
  edit: <IconEdit />,
  share: <IconShare />,
  delete: <IconTrash />,
  remove: <IconTrash />,
  cancel: <IconClose />,
  close: <IconClose />,
  deny: <IconClose />,
  view: <IconEye />,
  preview: <IconEye />,
  open: <IconEye />,
  document: <IconDocument />,
  download: <IconDocument />,
  save: <IconDocument />,
  upload: <IconDocument />,
  attach: <IconDocument />,
  image: <IconImage />,
  gallery: <IconImage />,
  "photo-library": <IconImage />,
  camera: <IconCamera />,
  "take-photo": <IconCamera />,
  scan: <IconScan />,
  confirm: <IconCheck />,
  status: <IconStatus />
};

const ICON_MAP: Record<ActionSheetIconId, ReactNode> = {
  edit: AUTO_ICON_MAP.edit,
  share: AUTO_ICON_MAP.share,
  delete: AUTO_ICON_MAP.delete,
  close: AUTO_ICON_MAP.close,
  document: AUTO_ICON_MAP.document,
  scan: AUTO_ICON_MAP.scan,
  image: AUTO_ICON_MAP.image,
  camera: AUTO_ICON_MAP.camera,
  view: AUTO_ICON_MAP.view,
  details: AUTO_ICON_MAP.details,
  status: AUTO_ICON_MAP.status
};

const isIconId = (icon: unknown): icon is ActionSheetIconId =>
  typeof icon === "string" && icon in ICON_MAP;

export const getAutoIconForId = (id: string): ReactNode | undefined => {
  return AUTO_ICON_MAP[id];
};

export const getButtonIcon = (
  button: InternalActionSheetOptions["buttons"][number]
): ReactNode | undefined => {
  if (button.icon !== undefined) {
    if (isIconId(button.icon)) {
      return ICON_MAP[button.icon];
    }
    if (isValidElement(button.icon)) {
      return button.icon;
    }
    return undefined;
  }
  return getAutoIconForId(button.id);
};
